export default __webpack_public_path__ + "static/media/silpo-logo.ae75a7ce.png";